// components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import "./css/Footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        {/* Branding */}
        <div className="footer-brand">
          <p className="footer-copy">
            © {new Date().getFullYear()} <strong>GTAFanPage.com</strong>
          </p>
          <p className="footer-network">
            Part of an independent Rockstar fan network
            <span>
              <a href="https://www.gtafanpage.com">GTAFanPage</a> •{" "}
              <a href="https://www.rdrfan.com">RDRFan</a>
            </span>
          </p>
        </div>

        {/* Links */}
        <nav className="footer-links" aria-label="Footer navigation">
          <Link to="/about-us">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/terms-and-conditions">Terms</Link>
          <Link to="/privacy-policy">Privacy</Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
